// extracted by mini-css-extract-plugin
export default {"title":"SmallClock_title__BkzBY"};